import * as z from 'zod'

import { DocumentStatusPayload } from './types'

export const documentStatusReportPayloadSchema = z.object({
  sortBy: z.string().optional().nullable(),
  documentName: z.string().optional().nullable(),
  customerStatus: z.string().optional().nullable(),
  sortDesc: z.boolean().optional().nullable(),
  isAccepted: z.boolean().optional().nullable(),
  page: z.number().int().positive().default(1),
  size: z.number().int().positive().default(10)
}) as z.ZodType<DocumentStatusPayload>
